import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/index/layout/index.vue'
Vue.use(VueRouter)
// 初始路由r
export const routes = [{
        path: '/',
        // redirect: 'home',
        redirect: 'login',
        meta: {
            name: '初次访问',
        },
        hidden: true,
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            name: '登录',
        },
        hidden: true,
        component: () =>
            import('../views/login/login.vue'),
    }
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const route = new VueRouter({
    routes,
})


export default route